<template>
  <div>
    <div
      v-if="uploadedFiles.length"
      class="mt-2 flex w-full flex-col gap-y-2"
    >
      <div>
        <div
          v-for="(file, fIndex) in uploadedFiles"
          :key="`file-${fIndex}`"
        >
          <div
            v-if="file"
            class="relative mb-2 flex w-full items-center justify-between gap-x-2 rounded-lg border border-[#218579] bg-[#F2F6F8] px-4 py-2"
          >
            <span
              class="mr-3 line-clamp-1 w-5/6 whitespace-nowrap rounded-sm py-2 text-sm font-medium text-[#344054]"
            >
              {{ file.document_name_without_id }}
            </span>
            <div class="flex w-1/3 items-center justify-end gap-x-2">
              <button
                aria-label="Delete file"
                class="rounded-full bg-main-primary p-1.5 outline-none"
                type="button"
                @click="viewUploadedFile(file)"
              >
                <EyeIcon :custom-style="`text-white h-3 w-3 rounded-full`" />
              </button>
              <span class="mt-0 text-sm text-[#1A242A8C]">{{
                Number((file.file_size / 1024).toFixed(2)) > 1024
                  ? (file.file_size / 1024 / 1024).toFixed(2) + "MB"
                  : (file.file_size / 1024).toFixed(2) + "KB"
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EsgDataEntryDocumentViewer',

  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['fileDocument', 'getDocument'],

  data() {
    return {
      uploadedFiles: this.fileList,
      fileErrorMessage: null,
      attachedDocuments: [],
    }
  },

  watch: {
    fileList(newFiles) {
      this.uploadedFiles = newFiles
    },
  },

  methods: {
    checkAttachedFileType(file) {
      this.fileErrorMessage = null
      this.fileUploadError = false
      this.$emit('fileDocument', file)
    },
    viewUploadedFile(filename) {
      this.$emit('getDocument', filename)
    },
  },
}
</script>
